var _ellipse, _path, _path2, _ellipse2, _ellipse3, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChatSupportWhite = function SvgChatSupportWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4998,
    cy: 11.611,
    rx: 1.2,
    ry: 1.16667,
    fill: "#FAFBFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 10.4443H19.5C20.0523 10.4443 20.5 10.8921 20.5 11.4443V14.111C20.5 14.6633 20.0523 15.111 19.5 15.111H18.1",
    stroke: "#FAFBFC",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 15.1111V10.4444C6.90039 8.5 7.38039 5 12.5004 5C16.1004 5 18.1004 6.94444 18.1004 10.4444C18.1004 13.2444 18.1004 14.9815 18.1004 15.5C18.1004 16.1481 17.4604 17.4444 14.9004 17.4444",
    stroke: "#FAFBFC",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.4998,
    cy: 11.611,
    rx: 1.2,
    ry: 1.16667,
    fill: "#FAFBFC"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.3002,
    cy: 17.4445,
    rx: 1.6,
    ry: 1.55556,
    fill: "#FAFBFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 10.4443H5.5C4.94771 10.4443 4.5 10.8921 4.5 11.4443V14.111C4.5 14.6633 4.94772 15.111 5.5 15.111H6.9",
    stroke: "#FAFBFC",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatSupportWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat-support-white.725e74b6.svg";
export { ForwardRef as ReactComponent };